import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-month-end-draw-recost',
    templateUrl: './month-end-draw-recost.component.html',
    styleUrls: ['./month-end-draw-recost.component.scss'],
    standalone: false
})
export class MonthEndDrawRecostComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.monthEndDrawRecost;
    chartSearchFilters: widgetFilters[] = [widgetFilters.invoiceStatus,
    widgetFilters.customer,
    widgetFilters.acctMgr,
    widgetFilters.divisions,
    widgetFilters.contAdmin,
    widgetFilters.class,
        widgetFilters.state,
        widgetFilters.divisions,
        widgetFilters.onCallRegion, 
        widgetFilters.biller];

    ngOnInit() {
     
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
